module.exports = __webpack_public_path__ + "fonts/visuelt-pro-regular.0fe9ec22.eot";